var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,12V7c0-2.76-2.24-5-5-5h-6c-2.76,0-5,2.24-5,5v5c-2.21,0-4,1.79-4,4v2c0,2.21,1.79,4,4,4H20c2.21,0,4-1.79,4-4v-2c0-2.21-1.79-4-4-4ZM6,7c0-1.65,1.35-3,3-3h6c1.65,0,3,1.35,3,3v9H6V7Zm16,11c0,1.1-.9,2-2,2H4c-1.1,0-2-.9-2-2v-2c0-1.1,.9-2,2-2v3c0,.55,.45,1,1,1h14c.55,0,1-.45,1-1v-3c1.1,0,2,.9,2,2v2Zm-12.71-6.71l1.29-1.29-1.29-1.29c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l1.29,1.29,1.29-1.29c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.29,1.29,1.29,1.29c.39,.39,.39,1.02,0,1.41-.2,.2-.45,.29-.71,.29s-.51-.1-.71-.29l-1.29-1.29-1.29,1.29c-.2,.2-.45,.29-.71,.29s-.51-.1-.71-.29c-.39-.39-.39-1.02,0-1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/Suspend.defe2c19bb18d1923838e363e26388d2.svg";
export { ForwardRef as ReactComponent };